import { render, staticRenderFns } from "./SiteConfig.vue?vue&type=template&id=23ed070c"
import script from "./SiteConfig.vue?vue&type=script&lang=js"
export * from "./SiteConfig.vue?vue&type=script&lang=js"
import style0 from "./SiteConfig.vue?vue&type=style&index=0&id=23ed070c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports